export function logEvent(npoPlayer, event, data) {
    if (!npoPlayer.player || !npoPlayer.streamTracker || npoPlayer.adBreakActive || npoPlayer.player.isCasting())
        return;
    if (data === undefined || Object.keys(data).length === 0)
        data = { stream_position: 0 };
    const eventHandlers = {
        start: npoPlayer.streamTracker.start,
        buffering: npoPlayer.streamTracker.buffering,
        buffering_complete: npoPlayer.streamTracker.buffering_complete,
        complete: npoPlayer.streamTracker.complete,
        fullscreen: npoPlayer.streamTracker.fullscreen,
        load: npoPlayer.streamTracker.load,
        load_complete: npoPlayer.streamTracker.load_complete,
        pause: npoPlayer.streamTracker.pause,
        resume: npoPlayer.streamTracker.resume,
        stop: npoPlayer.streamTracker.stop,
        windowed: npoPlayer.streamTracker.windowed,
        time: npoPlayer.streamTracker.time,
        seek: () => {
            npoPlayer.streamTracker?.seek(data);
        }
    };
    const streamTrackerHandler = eventHandlers[event];
    npoPlayer.logEmitter.emit('logEvent', event, data);
    streamTrackerHandler(data);
}
